import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    OnDestroy,
} from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { Router } from '@angular/router';
import { SuccessfulPurchase } from './successful-purchase.interface';
import printJS from 'print-js';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CheckoutState, SuccessfulPurchaseState } from '../checkout.state';
import { NotificationService } from 'src/app/shared/notification/notification.service';

const query = gql`
    query Query {
        olsPurchasedGiftCard @client {
            recipientEmail
            transactionID
            printableHtml
            giftCardAmount
            giftCardID
        }
    }
`;

@Component({
    selector: 'ols-successful-purchase',
    templateUrl: './successful-purchase.component.html',
    styleUrls: ['./successful-purchase.component.scss'],
})
export class SuccessfulPurchaseComponent implements OnInit, OnDestroy {
    purchasedGiftCard: SuccessfulPurchase;
    containerId = 'PrintGiftCard';
    private ngUnsubscribe: Subject<any> = new Subject();
    @ViewChild('printGiftCardContainer') giftCard: ElementRef;

    constructor(
        private router: Router,
        private apollo: Apollo,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        this.apollo
            .watchQuery({ query })
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                if (response?.data?.olsPurchasedGiftCard) {
                    this.purchasedGiftCard = response.data.olsPurchasedGiftCard;
                    this.giftCard.nativeElement.innerHTML = this.purchasedGiftCard.printableHtml;
                } else {
                    this.notificationService.showFailure(response?.errors);
                }
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    print() {
        printJS({
            printable: this.containerId,
            type: 'html',
            targetStyles: ['*'],
            scanStyles: false,
            style: `
                   #${this.containerId} {
                    display: block !important;
                    width: 440px;
                }
                @page{
                    margin: 0;
                   }
                   tr {
                       text-align: left !important;
                   }
                   `,
        });
    }

    purchaseAnotherGiftCard() {
        CheckoutState(null);
        SuccessfulPurchaseState(null);
        this.router.navigate(['/gift']);
    }
}
